import React from 'react';
import { hashHistory } from 'react-router';
import '../css/App.css';
import { FormControl, FormGroup, Button, Alert, Row, Col } from 'react-bootstrap';
import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';
import { authContext } from '../AzureAd';

export default class AddMaintenanceCaseComponent extends React.Component {

	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	checkIn(value) {
		let result = parseInt(value, 10);
		return result == value && result >= 0;
	}

	componentWillMount() {
	}

	componentDidMount() {
		this.props.findAllCustomerIds();
		this.props.findAllOrderIds();
	}

	componentWillUnmount() {
		this.props.cleanAlert();
	}

	handleSubmit(type) {
		let orderId = this.props.mCaseRequest.get('orderId');
		let note = this.props.mCaseRequest.get('note');
		let receivedDate = this.props.mCaseRequest.get('receivedDate');
		let returnDate = this.props.mCaseRequest.get('returnDate');

		if ('included' === type) {
			// (customerId, orderId, uploadFile) 
			if (this.checkRequired(orderId) ||
				this.checkRequired(note) ||
				this.checkRequired(this.uploadFile2)) {
				this.props.alertRequired();
			} else {
				this.props.createMaintenanceCaseWithSerial(
					orderId,
					note,
					receivedDate,
					returnDate,
					this.uploadFile2,
					authContext.getCachedUser().userName);
				this.props.clearState();
			}


		} else if ('customized' === type) {
			// (customerId, orderId, prefix, initNo, uploadFile)
			if (this.checkRequired(orderId) ||
				this.checkRequired(note) ||
				this.checkRequired(this.uploadFile1)) {
				this.props.alertRequired();
			} else {
				let prefix = this.props.mCaseRequest.get('prefix');

				if (!this.checkPrefix(prefix)) {
					this.props.alertMessage('序號前綴必須是大寫字母');
				} else {
					this.props.createMaintenanceCase(
						orderId,
						this.props.mCaseRequest.get('prefix'),
						this.props.mCaseRequest.get('init'),
						this.props.mCaseRequest.get('org'),
						this.props.mCaseRequest.get('unit'),
						note,
						this.uploadFile1,
						authContext.getCachedUser().userName);
					this.props.clearState();
				}
			}
		}
	}

	checkPrefix(input) {
		// console.log('input', input);
		let regex = new RegExp("^[A-Z]{1}$");
		let ret = regex.test(input)
		// console.log('ret', ret);
		return ret;

	}

	checkRequired(input) {
		return input === '' || input == null || input == undefined;
	}

	goToMCasesPage() {
		this.props.clearState();
		this.props.forwardToMCasesPage();
		hashHistory.push("/maintenanceCases");
	}

	render() {

		let alertDiv = null;
		if (this.props.alert.get('style') || this.props.alert.get('message')) {
			alertDiv = (
				<Alert bsStyle={this.props.alert.get('style')} onDismiss={this.props.cleanAlert}>
					{this.props.alert.get('message')}
				</Alert>
			);
		}

		return (
			<div>
				<h4>
					<span hidden> AddMaintenanceCaseComponent </span>
					清點作業管理 &gt;&gt; 建立作業資訊 &nbsp;
					<a onClick={(e) => { this.goToMCasesPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
				</h4>
				<Row>
					<Col>
						{alertDiv}
						<table width="60%">
							<tbody>
								<tr>
									<th>訂單編號 <span className="required">*</span> : </th>
									<td>
										<DropDownInput id="orderId"
											options={this.props.allOrderIds.map((value, key) => ({ label: value.get('display'), value: value.get('order_id') })).toJS()}
											selected={[{ label: this.props.mCaseRequest.get('orderId'), value: this.props.mCaseRequest.get('orderId') }]}
											onChange={(id, value, label) => {
												this.props.setValue('orderId', value);
											}}
										/>
									</td>
									<td>&nbsp;&nbsp;<span className="hint">AIQO1234</span></td>
								</tr>
								<tr>
									<th>註記 <span className="required">*</span> : </th>
									<td>
										<FieldGroup id="note"
											type="text"
											value={this.props.mCaseRequest.get('note')}
											onChange={(id, value) => {
												this.props.setValue(id, value);
											}}
											maxLength='50'
										/>
									</td>
									<td>&nbsp;&nbsp;</td>
								</tr>
								<tr>
									<th>收件日期 : </th>
									<td>
										<FieldGroup id="receivedDate"
											type="date"
											value={this.props.mCaseRequest.get('receivedDate')}
											onChange={(id, value) => {
												this.props.setValue(id, value);
											}}
										/>
									</td>
									<td>&nbsp;&nbsp;</td>
								</tr>
								<tr>
									<th>送回日期 : </th>
									<td>
										<FieldGroup id="returnDate"
											type="date"
											value={this.props.mCaseRequest.get('returnDate')}
											onChange={(id, value) => {
												this.props.setValue(id, value);
											}}
										/>
									</td>
									<td>&nbsp;&nbsp;</td>
								</tr>
							</tbody>
						</table>
						<div className='blockMarginEven' hidden="hidden">
							<h4 >自訂起始序號:</h4>
							<table width="80%"><tbody>
								<tr>
									<th width="10%">序號前綴 : </th>
									<td width="35%"><input id="prefix" className='form-control'
										type="text"
										value={this.props.mCaseRequest.get('prefix')}
										onChange={(event) => {
											this.props.setValue('prefix', event.target.value.toUpperCase());
										}}
										maxLength='1'
									/></td>
									<td width="10%"><span className="hint">A&nbsp;</span></td>
									<th width="10%"> 起始序號 : </th>
									<td width="35%">
										<input type="number" className='form-control'
											id="init"
											min="1"
											step='1'
											value={this.props.mCaseRequest.get('init')}
											onChange={(event) => {
												let value = event.target.value;
												if (this.checkIn(value)) {
													this.props.setValue('init', value);
												} else {
													alert('起始序號' + event.target.value + '格式錯誤:正整數');
												}
											}}
										/>
									</td>
								</tr>
								<tr>
									<th width="10%">大隊 : </th>
									<td width="35%">
										<input type="text" className='form-control' id='org'
											onChange={(e) => {
												this.props.setValue('org', e.target.value);
											}}
											value={this.props.mCaseRequest.get('org')}
										/>

									</td><td width="10%">&nbsp;</td>
									<th width="10%"> 分隊 : </th>
									<td width="35%">
										<input type="text" className='form-control' id='unit'
											onChange={(e) => {
												this.props.setValue('unit', e.target.value);
											}}
											value={this.props.mCaseRequest.get('unit')} />
									</td>
								</tr>
								<tr>
									<th>使用者 : </th>
									<td colSpan='10'>
										<input type='file' onChange={(event) => {
											this.uploadFile1 = event.target.files[0];
										}} /><span style={{ color: 'red' }}>檔案必須為 *.xls 格式</span>
										<a href="files/MaintenanceCaseTemplate.xls">&nbsp;&nbsp;範例檔</a>&nbsp;&nbsp;
										 <a href="doc/mcase-upload.html" target="_blank">
											<img src='question.svg' height="20" width="20" alt="" />
										</a>
									</td>
								</tr>
								<tr><th></th>
									<td colSpan='10' style={{ textAlign: 'right' }}> <Button bsStyle='primary' onClick={(event) => {
										this.handleSubmit('customized');
									}}>建立標案</Button>
									</td></tr></tbody>
							</table>
						</div>

						<div className='blockMarginEven'>
							<h4>檔案內含序號:</h4>
							<table width="60%">
								<tbody>
									<tr>
										<th>使用者清單 :<br /> <span className='hint-boild'>檔案需內含序號:</span> </th>
										<td>
											<FormGroup controlId="users_upload2" >
												<FormControl
													type="file"
													onChange={(event) => {
														this.uploadFile2 = event.target.files[0];
													}}
												/><span style={{ color: 'red' }}>檔案必須為　*.xls 格式</span>&nbsp;&nbsp;
										     	<a href="files/MaintenanceCaseTemplate.xls">範例檔</a>&nbsp;&nbsp;
												<a href="doc/mcase-upload-download.html" target="_blank">
												<img src='question.svg' height="20" width="20" alt="" />說明
												</a>
											</FormGroup>
										</td><td>&nbsp;</td>
									</tr>
									<tr><th> </th><td colSpan='10' style={{ textAlign: 'right' }}> <Button bsStyle='primary' onClick={(event) => {
										this.handleSubmit('included');
									}}>建立作業</Button> </td></tr>
								</tbody>
							</table>
						</div>
					</Col>
				</Row>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/AddMaintenanceCaseComponent.jsx